
import React from "react";
import { format, parseISO } from "date-fns";
import { TripElement } from "@/types/trip";
import { Calendar, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";

export interface DefaultSegmentProps {
  segment: TripElement;
}

const DefaultSegment: React.FC<DefaultSegmentProps> = ({ segment }) => {
  const { t } = useTranslation();
  
  return (
    <div className="bg-travel-50 rounded-lg p-4">
      <div className="flex flex-col gap-3">
        <div>
          <div className="font-medium text-travel-700 capitalize">
            {segment.type}
          </div>
          <div className="text-sm text-travel-500 mt-1">
            {segment.details && (segment.details as any).name
              ? (segment.details as any).name 
              : t("tripCard.noDetails", "No additional details")}
          </div>
        </div>
        
        <div className="flex items-center gap-2 text-xs text-travel-500">
          <Calendar className="w-3 h-3" />
          <div className="flex space-x-2">
            <span>{format(parseISO(segment.startDate || "1970"), "MMM d, HH:mm")}</span>
            <span>→</span>
            <span>{format(parseISO(segment.endDate || "1970"), "MMM d, HH:mm")}</span>
          </div>
        </div>
        
        {segment.details && (segment.details as any).address && (
          <div className="flex items-center gap-2 text-xs text-travel-500">
            <MapPin className="w-3 h-3" />
            <span>{(segment.details as any).address}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DefaultSegment;
